import React, { useState } from "react";
import image from "../../assets/loginn.jpeg";
//import styles from "../../scss/";
import './login.css';
import { useNavigate } from "react-router";
import {
  Box,
  TextField,
  Grid,
} from "@mui/material";
import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import loginService from "../../service/loginService";
import CommonUtils from "../../utilities/CommonUtils";
import useAuth from "../../hooks/useAuth";
import { SUCCESS } from "../../constants/Constants";

const LoginForm = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState(" ");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const { loginData } = useAuth();
  const handleSubmit = (e) => {
    // console.log(email, password);
    e.preventDefault();
    if (email !== "" && password !== "") {
      let encodedPassword = CommonUtils.encode(password);
      loginService
        .login(email, encodedPassword)
        .then((res) => {
          if (res.data.status === SUCCESS) {
            const loginDetails = res.data.payLoad;
            console.log("loginDetails: ", loginDetails);
            sessionStorage.setItem("authUser", JSON.stringify(loginDetails));
            sessionStorage.setItem("isLoggedIn", true);
            loginData({
              apiToken: loginDetails.apiToken,
              isOwner: loginDetails.isOwner,
              admin: loginDetails.admin,
              firstTimeLogin: loginDetails.firstTimeLogin,
              employeeType: loginDetails.employeeType,
              roles: loginDetails.roles,
              activeShopHash: loginDetails.activeShopHash,
              listshopHash: loginDetails.listshopHash,
              onlinePayMethod: loginDetails.onlinePayMethod,
              pointMethod: loginDetails.pointMethod,
              packages: loginDetails.packages,
              isLoggedIn: true,
            });
            navigate("/home");
          } else {
            setError(true);
            setErrorMessage("Email and Password is wrong!Please enter correct credentials");
          }
        })
        .catch((error) => {
          console.log("Login error", error);
          //console.log(error);
          setError(true);
          setErrorMessage("Email and Password is wrong!Please enter correct credentials");
        });
    }
  };

  return (
    <div className="login-form-container">
      <form onSubmit={handleSubmit}>
        <Box className="login-form-Box" marginTop={10}>
          <Grid item>
            <div>
              <img alt="" className="section-login-Image" src={image} />
            </div>
          </Grid>

          <TextField
            fullWidth
            required
            margin="normal"
            type={"email"}
            variant="outlined"
            placeholder="Email"
            value={email}
            onChange={(e) => {
              setError(false);
              setEmail(e.target.value);
            }}
          />
          <TextField
            fullWidth
            required
            margin="normal"
            type={"password"}
            variant="outlined"
            placeholder="Password"
            value={password}
            onChange={(e) => {
              setError(false);
              setPassword(e.target.value);
            }}
          />
          {error ? (
            <Stack sx={{ width: "100%" }} spacing={2}>
              <Alert severity="error">{errorMessage}</Alert>
            </Stack>
          ) : (
            ""
          )}

          <button
            color="primary"
            sx={{ marginTop: 3, borderRadius: 3 }}
            variant="contained"
            type="Submit"
            className="login-button"
          >
            Login
          </button>
        </Box>
      </form>
    </div>
  );
};

export default LoginForm;
